import { render, staticRenderFns } from "./highFrequencyWordPage.vue?vue&type=template&id=64dc74e9&"
import script from "./highFrequencyWordPage.vue?vue&type=script&lang=js&"
export * from "./highFrequencyWordPage.vue?vue&type=script&lang=js&"
import style0 from "./highFrequencyWordPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports